import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';

const AllowPlansPerNumber = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);
    const options = [
        { id: 0, name: 'Disabled' },
        { id: 1, name: 'Enabled' },
        { id: 2, name: 'Partner Only' },
        // Add more options as needed
    ];
    const handleSelectChange = (item) => {
        updateFormData(billingFieldPaths.PER_NUMBER_PLAN, item?.id);
    };
    const hasError = !!errors?.allowPlansPerNumber;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Allow Plans Per Number
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={billingFieldPaths.PER_NUMBER_PLAN}
                        name={billingFieldPaths.PER_NUMBER_PLAN}
                        data={options}
                        shownValue="name"
                        currentId={billingSettings?.perNumberPlan}
                        selectedId="id"
                        placeholder="Select plan allowance"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={false}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select plan allowance per number for this company"
                        ariaLabel="allowplanspernumber-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FormErrorMessage>{errors.allowPlansPerNumber}</FormErrorMessage>
        </FormControl>
    );
};
export default AllowPlansPerNumber;
